import { BetaBarTemplate } from "./template";


export const BetaItem = (): JSX.Element => {
    return (
        <BetaBarTemplate />
    )
}